import { Control, useController, FieldPathByValue, FieldValues } from "react-hook-form";
import { DateValueType } from "react-tailwindcss-datepicker";
import DateSelect from "@/components/DateSelect";

interface SingleDatePickerProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  label: string;
  required?: boolean;
  name: FieldPathByValue<TFieldValues, string>;
  supportingText?: string;
  useModal?: boolean;
}

export default function SingleDatePicker<TFieldValues extends FieldValues>({
  control,
  label,
  required = false,
  name,
  supportingText,
  useModal = false
}: SingleDatePickerProps<TFieldValues>) {
  const {
    field: { onChange, value },
    fieldState: { error }
  } = useController({ control, name, rules: { required: required ? `${label} is required` : undefined } });

  return (
    <DateSelect
      label={required ? `${label} *` : label}
      value={{ startDate: value, endDate: value }}
      onChange={(x: DateValueType | string) => {
        if (typeof x === "string") return;

        if (x === null) {
          onChange("");
          return;
        }

        onChange(x.startDate);
      }}
      supportingText={supportingText}
      useSingleDate
      useMultiCalendar={false}
      error={!!error}
      errorMessage={error?.message}
      useModal={useModal}
    />
  );
}
